import React from 'react'
import moment from 'moment'
import { withTranslation } from 'react-i18next'
import withRouter from '../../../../../Common/withRouter'
import logo from './logo.png'

const MatrixCashierContent = (props) => {
  return ( 
        <div className="" 
            style={{ 
                fontFamily: "Courier, monospace", 
                backgroundColor: "#fefefe", 
                padding: "5px", 
                width: "80mm", // Largeur standard papier matriciel
                maxWidth: "80mm",
                margin: "0 auto",
                position: "relative",
                backgroundImage: `url(${logo})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "60%",
                backgroundOpacity: "0.05"
                }}
        >
            {/* Overlay pour le filigrane */}
            <div style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                opacity: "0.05",
                width: "60%",
                height: "60%",
                backgroundImage: `url(${logo})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
                zIndex: "0",
                pointerEvents: "none"
            }}></div>

            <div className="container" style={{ position: "relative", zIndex: "1", padding: "0", margin: "0" }}>
                <div className="header">
                    <div className="reg-no" style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "space-between", 
                        margin: "0 0 5px 0",
                        padding: "0"
                    }}>
                        <p style={{ 
                            fontFamily: "Courier, monospace", 
                            fontSize: "9px",
                            margin: "0",
                            padding: "0"
                        }}>{props.t("reg_no")}</p>
                        <p style={{ 
                            padding: "0", 
                            fontSize: "14px", 
                            fontFamily: "Courier, monospace", 
                            margin: "0",
                            fontWeight: "bold"
                        }}>{props.t("tax_invoice")}</p>
                    </div>
                    
                    {/* Logo et nom de l'hôpital */}
                    <div style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center",
                        gap: "10px",
                        margin: "5px 0"
                    }}>
                        <img 
                            src={logo} 
                            alt="Logo" 
                            style={{ 
                                width: "40px", 
                                height: "40px",
                                objectFit: "contain"
                            }} 
                        />
                        <h4 style={{ 
                            textAlign: "center", 
                            fontFamily: "Courier, monospace", 
                            fontWeight: "600",
                            margin: "0",
                            padding: "0",
                            fontSize: "16px"
                        }}>{props.t("hospital_name")}</h4>
                    </div>
                    
                    <h6 style={{ 
                        textAlign: "center", 
                        fontFamily: "Courier, monospace",
                        margin: "2px 0",
                        fontSize: "11px"
                    }}>{props.t("hospital_location")}</h6>
                    
                    <div style={{ 
                        display: "flex", 
                        justifyContent: "center", 
                        gap: "8px", 
                        margin: "2px 0",
                        flexDirection: "row",
                        fontSize: "9px",
                        flexWrap: "wrap"
                    }}>
                        <p style={{ fontFamily: "Courier, monospace", margin: "0" }}>{props.t("hospital_email")}</p>
                        <p style={{ fontFamily: "Courier, monospace", margin: "0" }}>{props.t("hospital_contact")}</p>
                    </div>
                </div>

                {props.section && props.section === "sale" ?
                    <>
                        <div className="section" style={{ marginBottom: "0", marginTop: "5px" }}>
                            <div className="m-0">
                                <table className="table table-borderless m-0" style={{ width: "100%", fontSize: "9px" }}>
                                    <tbody style={{ borderTop: "1px solid black" }}>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("bill_no")}:</th>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.sale && props.sale.orderRef}</td>

                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("patient_id")}:</th>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.sale && props.sale.patient && props.sale.patient.patientRef}</td>
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("date")}:</th>
                                            <td colSpan="3" style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.sale && moment(props.sale.orderDate).format('DD/MM/YYYY')}</td>
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("patient_name")}:</th>
                                            <td colSpan="3" style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.sale && props.sale.patient && props.sale.patient.firstName} {props.sale && props.sale.patient && props.sale.patient.lastName}</td>
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("gender")}:</th>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.sale && props.sale.patient && props.sale.patient.gender === "M" ? props.t("male") : props.t("female")}</td>
                                            
                                            {props.sale && props.sale.patientRecord && props.sale.patientRecord.bedRecords ?
                                                <>
                                                    <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("bed_no")}:</th>
                                                    <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>VIP 02</td>
                                                </>
                                                : <><td colSpan="2"></td></>
                                            }
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", verticalAlign: "top" }}>{props.t("address")}:</th>
                                            <td colSpan="3" style={{ fontFamily: "Courier, monospace", fontSize: "9px", padding: "2px" }}>
                                                {props.sale && props.sale.patient && props.sale.patient.address && props.sale.patient.address.address ? props.sale.patient.address.address : ""}
                                                {props.sale && props.sale.patient && props.sale.patient.address && props.sale.patient.address.city ? ", "+props.sale.patient.address.city : ""}
                                                {props.sale && props.sale.patient && props.sale.patient.address && props.sale.patient.address.region ? ", "+props.sale.patient.address.region : ""}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="section two" style={{ margin: "5px 0 0 0" }}>
                            <div className="m-0">
                                <table className="table table-borderless mb-4" style={{ width: "100%", fontSize: "9px" }}>
                                    <tbody>
                                        <tr style={{ borderTop: "1px solid black", borderBottom: "1px solid black" }}>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "center" }}>{props.t("s_no")}</th>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("ipd_service_details")}</th>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("qty")}</th>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("rate")}</th>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("discount")}</th>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("amount")}</th>
                                        </tr>

                                        {props.items && props.items.map((row, index) => (
                                            <tr key={index}>
                                                <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "center" }}>{index+1}</td>
                                                <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{row.label}</td>
                                                <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{row.quantity}</td>
                                                <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{row.unitPrice}</td>
                                                <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{row.discount}</td>
                                                <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{row.rowTotal}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="section" style={{ marginTop: "5px" }}>
                            <div className="m-0">
                                <table className="table table-borderless m-0" style={{ width: "100%", fontSize: "9px" }}>
                                    <tbody>
                                        <tr style={{ borderTop: "1px solid black" }}>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right", fontWeight: "bold" }}>
                                                {props.t("total_amount")}:
                                            </td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right", width: "30%" }}>
                                                {props.totalAmount}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right", fontWeight: "bold" }}>
                                                {props.t("amount_recieved")}:
                                            </td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>
                                                {props.amountRecieved}
                                            </td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid black" }}>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right", fontWeight: "bold" }}>
                                                {props.t("amount_return")}:
                                            </td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>
                                                {props.amountRecieved > props.totalAmount ? props.amountRecieved - props.totalAmount : 0}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                : props.section && props.section === "payment" ?
                    <>
                        <div className="section" style={{ marginBottom: "0", marginTop: "5px" }}>
                            <div className="m-0">
                                <table className="table table-borderless m-0" style={{ width: "100%", fontSize: "9px" }}>
                                    <tbody style={{ borderTop: "1px solid black" }}>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("bill_no")}:</th>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>LAB-756</td>

                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("patient_id")}:</th>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>12334</td>
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("date")}:</th>
                                            <td colSpan="3" style={{ fontFamily: "Courier, monospace", padding: "2px" }}>09/02/2024</td>
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("patient_name")}:</th>
                                            <td colSpan="3" style={{ fontFamily: "Courier, monospace", padding: "2px" }}>ALEX THOMAS</td>
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("gender")}:</th>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>Male</td>

                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("age")}:</th>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>25</td>
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("pr_by")}:</th>
                                            <td colSpan="3" style={{ fontFamily: "Courier, monospace", padding: "2px" }}>Dr. S. WATSON</td>
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("bed_no")}:</th>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>VIP 02</td>
                                            <td colSpan="2"></td>
                                        </tr>
                                        <tr>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", verticalAlign: "top" }}>{props.t("address")}:</th>
                                            <td colSpan="3" style={{ fontFamily: "Courier, monospace", fontSize: "9px", padding: "2px" }}>BIPINDI, CAMEROON, AFRICA</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="section two" style={{ margin: "5px 0 0 0" }}>
                            <div className="m-0">
                                <table className="table table-borderless mb-4" style={{ width: "100%", fontSize: "9px" }}>
                                    <tbody>
                                        <tr style={{ borderTop: "1px solid black", borderBottom: "1px solid black" }}>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "center" }}>{props.t("s_no")}</th>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("ipd_service_details")}</th>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("qty")}</th>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("rate")}</th>
                                            <th style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("amount")}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "center" }}>1</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>Operation Charge</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>1</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>256.81</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>256.81</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "center" }}>2</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>Bed Charge (VIP WARD 02)</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>1</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>85.07</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>85.07</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="totals" style={{ margin: "5px 0" }}>
                            <div className="m-0">
                                <table className="table table-borderless m-0" style={{ width: "100%", fontSize: "9px" }}>
                                    <tbody>
                                        <tr style={{ borderTop: "1px solid black" }}>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>{props.t("incl_taxes_details")}:</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>203.20x12%= 24.38, GST 0% AMT: 80.10</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("vat")}:</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right", fontWeight: "bold" }}>$ 12.19</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("gros")}:</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>$ 341.88</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>{props.t("less_dis")}:</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>$ 33.87</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="section" style={{ marginTop: "5px" }}>
                            <div className="m-0">
                                <table className="table table-borderless m-0" style={{ width: "100%", fontSize: "9px" }}>
                                    <tbody>
                                        <tr style={{ borderTop: "1px solid black" }}>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>E.& O.E. MATHEW 12:26pm</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right", fontWeight: "bold" }}>{props.t("total_amount")}:</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right", width: "25%" }}>$ 308.01</td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid black" }}>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px" }}>USD: Three Hundred and Eight Only</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right", fontWeight: "bold" }}>{props.t("net_amount")} (R/O):</td>
                                            <td style={{ fontFamily: "Courier, monospace", padding: "2px", textAlign: "right" }}>$ 308.00</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                :
                    null
                }

                <div className="footer" style={{ marginTop: "10px" }}>
                    <p style={{ 
                        fontSize: "12px", 
                        fontWeight: "bold", 
                        textAlign: "center", 
                        margin: "0 0 3px 0", 
                        padding: "0", 
                        fontFamily: "Courier, monospace" 
                    }}>{props.t("slogan")}</p>
                    <p style={{ 
                        textAlign: "center", 
                        fontFamily: "Courier, monospace",
                        fontSize: "9px",
                        margin: "0",
                        padding: "0"
                    }}>
                        {props.t("invoice_footer")} 
                        <span style={{ fontWeight: "bold", fontSize: "10px" }}> +237 6 75 55 38 64</span>
                    </p>
                </div>
            </div>
        </div>
  )
}

export default withRouter(withTranslation()(MatrixCashierContent))